/**
 * Maps Jobber table/list tone names to StatusBadge variants.
 * Tones "change" & "converted" keep legacy `.jobber-status-pill--*` (distinct pink/purple).
 */
export const JOBBER_TONE_TO_STATUS_VARIANT = {
  active: "success",
  approved: "success",
  paid: "success",
  scheduled: "info",
  draft: "neutral",
  inactive: "neutral",
  neutral: "neutral",
  unpaid: "error",
  overdue: "error",
  unscheduled: "warning",
};

const LEGACY_PILL_TONES = new Set(["change", "converted"]);

export function resolveJobberStatusDisplay(tone) {
  const t = String(tone ?? "neutral")
    .toLowerCase()
    .trim();
  if (LEGACY_PILL_TONES.has(t)) {
    return { kind: "legacy", tone: t };
  }
  return {
    kind: "badge",
    variant: JOBBER_TONE_TO_STATUS_VARIANT[t] ?? "neutral",
  };
}
